import * as Yup from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { isEmail } from 'validator';
import { Role } from '../../redux/coachGroup/coachGroupSlice';

export interface FormValues {
  id?: string;
  firstName: string;
  lastName?: string;
  email: string;
  phoneNumber?: string;
  role: Role;
}

export const initialValues: FormValues = {
  firstName: '',
  lastName: '',
  email: '',
  role: Role.ASSISTANT_COACH,
};

const isPhoneNumberValid = (value: string | undefined) => {
  if (value) {
    return isValidPhoneNumber(value);
  }
  return true;
};

const isEmailValid = (value: string | undefined) => {
  if (value) {
    return isEmail(value);
  }
  return true;
};

export const getValidationSchema = () =>
  Yup.object().shape({
    firstName: Yup.string()
      .required('addNewClient.validations.firstName')
      .max(100, 'addNewClient.validations.NameMax'),
    lastName: Yup.string()
      .required('addNewClient.validations.lastName')
      .max(100, 'addNewClient.validations.NameMax'),
    pronoun: Yup.string().optional(),
    email: Yup.string()
      .test('email', 'addNewClient.validations.emailInvalid', isEmailValid)
      .required('addNewClient.validations.emailRequired'),
    phoneNumber: Yup.string()
      .optional()
      .test('phoneNumber', 'addNewClient.validations.phoneNumberValid', isPhoneNumberValid),
  });
